import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { NetworkStatus } from '@cbridge-utils/network';
import { DictSymbolAction } from './dictSymbol.action';
import { initialState } from './dictSymbol.constant';

export const dictSymbolReducer = reducerWithInitialState(initialState)
  .case(DictSymbolAction.loadList.started, (state) => ({
    ...state,
    networkStatus: NetworkStatus.Started,
  }))
  .case(DictSymbolAction.loadList.done, (state, { result }) => ({
    ...state,
    list: result,
    networkStatus: NetworkStatus.Done,
  }))
  .case(DictSymbolAction.loadList.failed, (state) => ({
    ...state,
    networkStatus: NetworkStatus.Failed,
  }))
  .case(DictSymbolAction.destroy, () => initialState);
